export default __webpack_public_path__ + "static/media/awakenGif.d8771b85.gif";